module.exports = __webpack_public_path__ + "static/media/partner-btm-2.0bda065b.png";